import {
  AddClientPayload,
  AddLocationPayload,
  AddPrinterPayload,
  CreatePackingStationPayload,
  PackingStationsApiAdapter,
  PackingStationsPage,
  UpdatePackingStationPayload,
} from '../adapters/PackingStationsApiAdapter';
import { Filters } from '../models/Filters';
import { AvailableLocation, PackingStation, PackingStationDetail, Printer, TeamChild } from '../models/PackingStation';

export class Service {
  constructor(private apiAdapter: PackingStationsApiAdapter) {}

  // Obtiene el listado paginado
  async getPaginated(filters: Filters = {}): Promise<PackingStationsPage> {
    return this.apiAdapter.getPackingStationsPaginated(filters);
  }

  // Obtiene el detalle de un puesto
  async getById(id: number): Promise<PackingStationDetail> {
    return this.apiAdapter.getPackingStationById(id);
  }

  // Crea un nuevo puesto
  async create(payload: CreatePackingStationPayload): Promise<PackingStation> {
    return this.apiAdapter.createPackingStation(payload);
  }

  // Activa o desactiva un puesto
  async toggleStatus(id: number, active: boolean): Promise<any> {
    return this.apiAdapter.toggleStatus(id, active);
  }

  // Actualiza código del puesto (PUT /packing-stations/:id)
  async updatePackingStation(id: number, payload: UpdatePackingStationPayload): Promise<PackingStation> {
    return this.apiAdapter.updatePackingStation(id, payload);
  }

  // Añade impresora al puesto
  async addPrinter(id: number, payload: AddPrinterPayload): Promise<any> {
    return this.apiAdapter.addPrinter(id, payload);
  }

  // Quita impresora del puesto
  async removePrinter(id: number, printerRelationId: number): Promise<any> {
    return this.apiAdapter.removePrinter(id, printerRelationId);
  }

  // Añade cliente al puesto
  async addClient(id: number, payload: AddClientPayload): Promise<any> {
    return this.apiAdapter.addClient(id, payload);
  }

  // Quita cliente del puesto
  async removeClient(id: number, tenantExternalId: number): Promise<any> {
    return this.apiAdapter.removeClient(id, tenantExternalId);
  }

  // Añade ubicación al puesto
  async addLocation(id: number, payload: AddLocationPayload): Promise<any> {
    return this.apiAdapter.addLocation(id, payload);
  }

  // Elimina una ubicación global por ID
  async deleteLocation(locationId: number): Promise<void> {
    return this.apiAdapter.deleteLocation(locationId);
  }

  // Obtiene impresoras disponibles para el select
  async getPrinters(): Promise<Printer[]> {
    return this.apiAdapter.getPrinters();
  }

  // Obtiene clientes disponibles para el select
  async getTeamsChild(): Promise<TeamChild[]> {
    return this.apiAdapter.getTeamsChild();
  }

  // Obtiene ubicaciones disponibles para el select
  async getAvailableLocations(): Promise<AvailableLocation[]> {
    return this.apiAdapter.getAvailableLocations();
  }

  // Obtiene ubicaciones tipo Packing Station (type_id=6) vacías y disponibles
  async getAvailablePackingStationLocations(search?: string): Promise<AvailableLocation[]> {
    return this.apiAdapter.getAvailablePackingStationLocations(search);
  }

  // Crea una nueva ubicación global tipo Packing Station
  async createGlobalLocation(payload: { code: string; type_id: number; is_locked: boolean }): Promise<void> {
    return this.apiAdapter.createGlobalLocation(payload);
  }
}
